// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostBanner-TopBannerHeader-WAA4z {
	width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: top center;
}

.WhyHostBanner-bannerTitle-_r1XR {
	font-size: 50px;
	font-weight: 600;
	margin: 0 0 45px;
	line-height: 72px;
	color: var(--primary-foreground);
}

.WhyHostBanner-grid-m53ZD {
	display: grid;
	grid-template-columns: 1fr 1fr;
	background-color: var(--primary-gray-bg);
	min-height: 771px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.WhyHostBanner-bannerText-kFyLF {
	padding: 84px;
}

.WhyHostBanner-borderRadius-g4FFy {
	border-radius: 23px;
	padding: 11px 28px 13px;
}

.WhyHostBanner-learnIcon-qd_xn {
	-webkit-animation: WhyHostBanner-moveUpDown-ZwxGz 0.45s infinite alternate;
	animation: WhyHostBanner-moveUpDown-ZwxGz 0.45s infinite alternate;
	margin-top: 6px;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.WhyHostBanner-whyHostLearnMoreBtn-BlKcd {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 8px;
}

.WhyHostBanner-whyHostBtnFlex-x4oSH {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 15px 20px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

@-webkit-keyframes WhyHostBanner-moveUpDown-ZwxGz {
	0% {
		-webkit-transform: translateY(0);
		        transform: translateY(0);
	}

	100% {
		-webkit-transform: translateY(-5px);
		        transform: translateY(-5px);
	}
}

@keyframes WhyHostBanner-moveUpDown-ZwxGz {
	0% {
		-webkit-transform: translateY(0);
		        transform: translateY(0);
	}

	100% {
		-webkit-transform: translateY(-5px);
		        transform: translateY(-5px);
	}
}

@media(max-width:1200px) {
	.WhyHostBanner-grid-m53ZD {
		margin-top: 83px;
	}
}

@media (max-width:1024px) and (min-width:992px) {
	.WhyHostBanner-bannerText-kFyLF {
		padding: 0 65px;
	}
}

@media(max-width:991px) {
	.WhyHostBanner-TopBannerHeader-WAA4z {
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
	}

	.WhyHostBanner-bannerText-kFyLF {
		padding: 0 25px;
	}

	.WhyHostBanner-borderRadius-g4FFy {
		padding: 11px 20px 13px;
	}
}

@media screen and (max-width: 640px) {
	.WhyHostBanner-TopBannerHeader-WAA4z {
		min-height: 400px;
	}

	.WhyHostBanner-bannerSubTitle-PtcNh {
		font-size: 18px;
	}

	.WhyHostBanner-bannerText-kFyLF {
		padding: 70px 15px 20px;
	}

	.WhyHostBanner-bannerTitle-_r1XR {
		font-size: 36px;
		line-height: 46px;
	}

	.WhyHostBanner-grid-m53ZD {
		grid-template-columns: 100%;
	}
}`, "",{"version":3,"sources":["webpack://./src/routes/whyhostnew/WhyHostBanner.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,sBAAsB;CACtB,+BAA+B;AAChC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAGA;CACC,aAAa;CACb,8BAA8B;CAC9B,wCAAwC;CACxC,iBAAiB;CACjB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,0EAAsD;CACtD,kEAA8C;CAC9C,eAAe;CACf,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC;EACC,gCAAwB;UAAxB,wBAAwB;CACzB;;CAEA;EACC,mCAA2B;UAA3B,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,gCAAwB;UAAxB,wBAAwB;CACzB;;CAEA;EACC,mCAA2B;UAA3B,2BAA2B;CAC5B;AACD;;AAIA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,uBAAuB;CACxB;AACD;;AAEA;CACC;EACC,iBAAiB;CAClB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,2BAA2B;CAC5B;AACD","sourcesContent":[".TopBannerHeader {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tbackground-position: top center;\n}\n\n.bannerTitle {\n\tfont-size: 50px;\n\tfont-weight: 600;\n\tmargin: 0 0 45px;\n\tline-height: 72px;\n\tcolor: var(--primary-foreground);\n}\n\n\n.grid {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tbackground-color: var(--primary-gray-bg);\n\tmin-height: 771px;\n\talign-items: center;\n}\n\n.bannerText {\n\tpadding: 84px;\n}\n\n.borderRadius {\n\tborder-radius: 23px;\n\tpadding: 11px 28px 13px;\n}\n\n.learnIcon {\n\t-webkit-animation: moveUpDown 0.45s infinite alternate;\n\tanimation: moveUpDown 0.45s infinite alternate;\n\tmargin-top: 6px;\n\tflex-shrink: 0;\n}\n\n.whyHostLearnMoreBtn {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n}\n\n.whyHostBtnFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 15px 20px;\n\tflex-wrap: wrap;\n}\n\n@-webkit-keyframes moveUpDown {\n\t0% {\n\t\ttransform: translateY(0);\n\t}\n\n\t100% {\n\t\ttransform: translateY(-5px);\n\t}\n}\n\n@keyframes moveUpDown {\n\t0% {\n\t\ttransform: translateY(0);\n\t}\n\n\t100% {\n\t\ttransform: translateY(-5px);\n\t}\n}\n\n\n\n@media(max-width:1200px) {\n\t.grid {\n\t\tmargin-top: 83px;\n\t}\n}\n\n@media (max-width:1024px) and (min-width:992px) {\n\t.bannerText {\n\t\tpadding: 0 65px;\n\t}\n}\n\n@media(max-width:991px) {\n\t.TopBannerHeader {\n\t\tjustify-content: center;\n\t}\n\n\t.bannerText {\n\t\tpadding: 0 25px;\n\t}\n\n\t.borderRadius {\n\t\tpadding: 11px 20px 13px;\n\t}\n}\n\n@media screen and (max-width: 640px) {\n\t.TopBannerHeader {\n\t\tmin-height: 400px;\n\t}\n\n\t.bannerSubTitle {\n\t\tfont-size: 18px;\n\t}\n\n\t.bannerText {\n\t\tpadding: 70px 15px 20px;\n\t}\n\n\t.bannerTitle {\n\t\tfont-size: 36px;\n\t\tline-height: 46px;\n\t}\n\n\t.grid {\n\t\tgrid-template-columns: 100%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TopBannerHeader": `WhyHostBanner-TopBannerHeader-WAA4z`,
	"bannerTitle": `WhyHostBanner-bannerTitle-_r1XR`,
	"grid": `WhyHostBanner-grid-m53ZD`,
	"bannerText": `WhyHostBanner-bannerText-kFyLF`,
	"borderRadius": `WhyHostBanner-borderRadius-g4FFy`,
	"learnIcon": `WhyHostBanner-learnIcon-qd_xn`,
	"moveUpDown": `WhyHostBanner-moveUpDown-ZwxGz`,
	"whyHostLearnMoreBtn": `WhyHostBanner-whyHostLearnMoreBtn-BlKcd`,
	"whyHostBtnFlex": `WhyHostBanner-whyHostBtnFlex-x4oSH`,
	"bannerSubTitle": `WhyHostBanner-bannerSubTitle-PtcNh`
};
module.exports = ___CSS_LOADER_EXPORT___;
